module.exports = __webpack_public_path__ + "413b5637389275e6a6ac96d489be2724.pdf";